import { generateViewerUrl, ScreenshareTokenMap } from "@/js/api/screenshareApi";
import { OpenTabEvent, sendOpenTabBatch } from "@/js/api/eventApi";
import { getScreenShareViewerUrl } from "@/js/utils/getBackendUrl";

// generates a call id for a user that obfuscates their PID using a SHA digest
export const getUserCallId = async (userId: string, applianceId: string): Promise<string> => {
	const string = `${userId}_${applianceId}`;
	const msgBuffer = new TextEncoder().encode(string);
	const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
	const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
	// convert bytes to hex string
	return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
};

export const generateCallId = (classroomId: string): string => {
	const sessionId = (Math.random() + 1).toString(36).substring(7);
	return `${classroomId}_${sessionId}`;
};

export const createScreenshareOpenTabEvent = (
	callId: string,
	username: string,
	userCallId: string,
	apiKey: string,
	token: string
): OpenTabEvent => {
	return {
		recipients: [username],
		event_object: {
			url: generateViewerUrl(apiKey, token, userCallId, callId),
		},
	};
};

export const openScreenshareTabForStudents = async (
	tokens: ScreenshareTokenMap,
	usernameUserIDMapping: { [key: string]: string },
	callId: string,
	streamApiKey: string
): Promise<void> => {
	if (!streamApiKey) {
		return;
	}

	const events: OpenTabEvent[] = [];
	for (const userCallId in tokens) {
		const classroomUsername = usernameUserIDMapping[userCallId];
		const token = tokens[userCallId];
		const event = createScreenshareOpenTabEvent(callId, classroomUsername, userCallId, streamApiKey, token);
		events.push(event);
	}
	await sendOpenTabBatch(events);
};

export const isScreenshareUrl = (url: string): boolean => {
	const screenshareUrl = getScreenShareViewerUrl(window.location.hostname);
	return screenshareUrl.includes(url);
};
